/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { IssueConfigProviderEntryEntrypointProps } from './IssueConfigProviderEntry.entrypoint.types.tsx';

type IssueConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	IssueConfigProviderEntryEntrypointProps,
	{} | null
>;

export const issueConfigProviderEntrypoint: EntryPoint<IssueConfigProviderEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<IssueConfigProviderEntrypointComponent>(
			/* webpackChunkName: "ai-rovo-actions-issue-config-provider" */ './IssueConfigProviderEntry.tsx',
		),
		getPreloadProps: () => ({}),
	});
